import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { initialMapFiltersState } from "../../../widgets/map/mapAddons/mapOverlayWidget/roadWorksOverlay/map.filters.config";

export type MapRoadWorksFilters = {
    WorkState: any,
    StartDate: any,
    EventStandartTypeId: any
}

type MapRoadWorksSlice = {
    filterMenuIsExpanded: boolean,
    filterMenuActiveTabs: number[],
    mapFiltersState: MapRoadWorksFilters,
    appliedFilters: MapRoadWorksFilters,
    mapFiltersExpressions: object | null,
    tableUnderMapFiltersExpressions: object | null
}

function getInitialState() {
    const mapsPreferences = getItemWebStorage("mapsPreferences")?.["RoadWorks"]
    const { mapFiltersState: localMapFiltersState, appliedFilters: localAppliedFilters, filterMenuActiveTabs: localFilterMenuActiveTabs } = mapsPreferences ?? {}
    const mapFiltersState: MapRoadWorksFilters = localAppliedFilters
        ? localMapFiltersState as MapRoadWorksFilters
        : initialMapFiltersState
    const initialState: MapRoadWorksSlice = {
        filterMenuIsExpanded: false,
        filterMenuActiveTabs: localFilterMenuActiveTabs,
        mapFiltersState,
        appliedFilters: localAppliedFilters,
        mapFiltersExpressions: null,
        tableUnderMapFiltersExpressions: null,
    };
    return initialState
}

export const mapRoadWorksSlice = createSlice({
    name: 'mapRoadWorks',
    initialState: getInitialState(),
    reducers: {
        setFilterMenuIsExpanded(state, action: PayloadAction<any>) {
            state.filterMenuIsExpanded = action.payload
        },
        setFilterMenuActiveTabs(state, action: PayloadAction<any>) {
            state.filterMenuActiveTabs = action.payload
        },
        setMapFiltersState(state, action: PayloadAction<any>) {
            state.mapFiltersState = action.payload
        },
        patchMapFiltersState(state, action: PayloadAction<{ fieldName: keyof MapRoadWorksFilters, patch: any }>,
        ) {
            const { fieldName, patch } = action.payload;
            state.mapFiltersState[fieldName] = { ...state.mapFiltersState[fieldName], ...patch };
        },
        resetAllMapFilters(state) {
            state.mapFiltersState = structuredClone(initialMapFiltersState)
        },
        resetSingleMapFilter(state, action: PayloadAction<keyof MapRoadWorksFilters>) {
            const fieldName = action.payload
            if (fieldName in initialMapFiltersState) {
                state.mapFiltersState[fieldName] = structuredClone(initialMapFiltersState[fieldName])
            }
        },
        setAppliedFilters(state, action: PayloadAction<any>) {
            state.appliedFilters = action.payload
        },
        setMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.mapFiltersExpressions = action.payload
        },
        setTableUnderMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.tableUnderMapFiltersExpressions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setFilterMenuIsExpanded,
    setFilterMenuActiveTabs,
    setMapFiltersState,
    setAppliedFilters,
    patchMapFiltersState,
    resetAllMapFilters,
    resetSingleMapFilter,
    setMapFiltersExpressions,
    setTableUnderMapFiltersExpressions
} = mapRoadWorksSlice.actions;
export const mapRoadWorksReducer = mapRoadWorksSlice.reducer;
